const enUS: Record<string, string> = {
  "login.title": "VanNav Login",
  "login.brand": "VanNav",
  "login.username": "Username",
  "login.password": "Password",
  "login.submit": "Log In",
  "login.error.loginFailed": "Login failed",
  "login.error.networkError": "Login failed. Please check your network connection.",
  "home.search.placeholder": "Press any key to start searching",
  "home.tag.allTools": "All Tools",
  "home.tag.uncategorized": "Uncategorized",
  "home.tag.admin": "Admin Panel",
  "home.cache.networkFail": "Network request failed, attempting to restore from local cache",
  "home.cache.restored": "Tool data restored from local cache",
  "home.cache.restoreFailed": "Failed to restore from local cache",
  "admin.header.title": "VanNav Admin",
  "admin.header.home": "Back to Home",
  "admin.header.logout": "Log Out",
  "admin.sidebar.tools": "Tools",
  "admin.sidebar.categories": "Categories",
  "admin.sidebar.searchEngines": "Search Engines",
  "admin.sidebar.apiToken": "API Token",
  "admin.sidebar.settings": "Settings",
  "admin.sidebar.theme": "Theme",
  "admin.tools.title": "Tools Management",
  "admin.tools.total": "Total {count} items",
  "admin.tools.table.sort": "Sort",
  "admin.tools.table.name": "Name",
  "admin.tools.table.category": "Category",
  "admin.tools.table.url": "URL",
  "admin.tools.table.hidden": "Hidden",
  "admin.tools.table.hidden.tooltip": "When enabled, the tool is only visible after login",
  "admin.tools.table.status": "Status",
  "admin.tools.table.action": "Actions",
  "admin.tools.table.total": "Total {total} items",
  "admin.tools.status.normal": "Active",
  "admin.tools.status.dead": "Dead",
  "admin.tools.status.unchecked": "Unchecked",
  "admin.tools.btn.add": "Add",
  "admin.tools.btn.refresh": "Refresh",
  "admin.tools.btn.import": "Import",
  "admin.tools.btn.export": "Export",
  "admin.tools.btn.edit": "Edit",
  "admin.tools.btn.delete": "Delete",
  "admin.tools.bulk.delete": "Delete",
  "admin.tools.bulk.resetDefaultIcon": "Reset to Default Icon",
  "admin.tools.bulk.resetCacheIcon": "Reset Cached Icon",
  "admin.tools.bulk.updateLogo": "Batch Update Logo URL",
  "admin.tools.bulk.updateDesc": "Batch Update Description",
  "admin.tools.bulk.confirmDelete": "Are you sure you want to delete these?",
  "admin.tools.bulk.confirmResetDefault": "Are you sure you want to reset icons? (Default icons will be fetched automatically)",
  "admin.tools.bulk.confirmResetCache": "Are you sure you want to re-cache icons? (Icons will be fetched and cached to the database)",
  "admin.tools.bulk.confirmUpdateLogo": "Auto-fetch and update logo URLs for selected tools based on the Logo API template?",
  "admin.tools.bulk.confirmUpdateDesc": "Auto-fetch and update descriptions for selected tools?",
  "admin.tools.modal.add": "Add Tool",
  "admin.tools.modal.edit": "Edit Tool",
  "admin.tools.form.id": "ID",
  "admin.tools.form.name": "Name",
  "admin.tools.form.namePlaceholder": "Enter name",
  "admin.tools.form.nameRequired": "Please enter a name",
  "admin.tools.form.url": "URL",
  "admin.tools.form.urlPlaceholder": "Enter URL",
  "admin.tools.form.urlRequired": "Please enter the URL",
  "admin.tools.form.category": "Category",
  "admin.tools.form.categoryPlaceholder": "Select a category",
  "admin.tools.form.categoryRequired": "Please select a category",
  "admin.tools.form.desc": "Description",
  "admin.tools.form.descPlaceholder": "Enter description",
  "admin.tools.form.sort": "Sort",
  "admin.tools.form.sortPlaceholder": "Enter sort order",
  "admin.tools.form.sortTooltip": "Ascending order, sorted by number from low to high",
  "admin.tools.form.sortRequired": "Please enter a sort order",
  "admin.tools.form.hidden": "Hidden",
  "admin.tools.form.hiddenTooltip": "When enabled, the tool is only visible after login",
  "admin.tools.form.logo": "Logo",
  "admin.tools.form.logoUrl": "Logo URL",
  "admin.tools.form.logoPlaceholder": "Enter logo URL",
  "admin.tools.filter.category": "Filter by category",
  "admin.tools.form.autoGetLogo": "Auto-update Logo URL",
  "admin.tools.form.autoGetDesc": "Auto-fetch Description",
  "admin.tools.form.fillUrlFirst": "Please fill in the tool URL first",
  "admin.tools.form.getFaviconSuccess": "Favicon fetched successfully",
  "admin.tools.form.getFaviconFailed": "Fetch failed",
  "admin.tools.form.getFaviconError": "Failed to fetch favicon",
  "admin.tools.form.getDescSuccess": "Description fetched successfully",
  "admin.tools.form.getDescNotFound": "No description found, please enter manually",
  "admin.tools.form.getDescFailed": "Failed to fetch description",
  "admin.tools.confirm.delete": "Are you sure you want to delete {name}?",
  "admin.tools.confirm.deleteBulk": "Are you sure you want to delete the selected tools?",
  "admin.tools.msg.addSuccess": "Added successfully! Logo will refresh and load in 3 seconds!",
  "admin.tools.msg.addFailed": "Failed to add!",
  "admin.tools.msg.updateSuccess": "Updated successfully! Logo will refresh and load in 3 seconds!",
  "admin.tools.msg.updateFailed": "Update failed!",
  "admin.tools.msg.deleteSuccess": "Deleted successfully!",
  "admin.tools.msg.deleteFailed": "Delete failed!",
  "admin.tools.msg.toggleSuccess": "Updated successfully",
  "admin.tools.msg.toggleFailed": "Update failed",
  "admin.tools.msg.exportSuccess": "Export successful!",
  "admin.tools.msg.importEmpty": "Import data is empty",
  "admin.tools.msg.importing": "Importing {count} tools...",
  "admin.tools.msg.importComplete": "Import complete: {imported} items succeeded",
  "admin.tools.msg.importSkipped": ", {skipped} duplicates skipped (ID already exists)",
  "admin.tools.msg.importRefreshing": ", refreshing icon cache...",
  "admin.tools.msg.importFailed": "Import failed!",
  "admin.tools.msg.resetSuccess": "Reset successfully!",
  "admin.tools.msg.resetFailed": "Reset failed!",
  "admin.tools.msg.updateLogoProgress": "Updating logo URLs...",
  "admin.tools.msg.updateDescProgress": "Fetching descriptions...",
  "admin.tools.msg.bulkUpdateComplete": "Update complete: {success} succeeded, {fail} failed",
  "admin.tools.msg.sortSuccess": "Sort order updated",
  "admin.tools.msg.sortFailed": "Failed to update sort order",
  "admin.tools.health.title": "Website Health Check",
  "admin.tools.health.startCheck": "Start Check",
  "admin.tools.health.checking": "Checking...",
  "admin.tools.health.checkingTip": "Checking all links, please wait...",
  "admin.tools.health.checkFailed": "Check failed",
  "admin.tools.health.checkRequestFailed": "Check request failed: ",
  "admin.tools.health.checkComplete": "Check complete: {alive} alive, {dead} dead",
  "admin.tools.health.organizeDeadLinks": "Organize Dead Links",
  "admin.tools.health.confirmOrganize": "Move {count} dead links to the end of the list?",
  "admin.tools.health.organizeSuccess": "Organized {count} dead links",
  "admin.tools.health.organizeFailed": "Organize failed",
  "admin.tools.health.organizeRequestFailed": "Organize request failed: ",
  "admin.tools.health.total": "Total",
  "admin.tools.health.alive": "Alive",
  "admin.tools.health.dead": "Dead",
  "admin.tools.health.table.name": "Name",
  "admin.tools.health.table.url": "URL",
  "admin.tools.health.table.statusCode": "Status Code",
  "admin.tools.health.table.status": "Status",
  "admin.tools.health.table.error": "Error",
  "admin.tools.health.table.total": "Total {total} items",
  "admin.tools.health.unreachable": "Unreachable",
  "admin.tools.health.hint": "Click \"Start Check\" to check the availability of all registered websites",
  "admin.common.switch.on": "On",
  "admin.common.switch.off": "Off",
  "admin.catelog.title": "Category Management",
  "admin.catelog.total": "Total {count} items",
  "admin.catelog.table.sort": "Sort",
  "admin.catelog.table.name": "Name",
  "admin.catelog.table.hidden": "Hidden",
  "admin.catelog.table.hidden.tooltip": "When enabled, this category is only visible after login",
  "admin.catelog.table.action": "Actions",
  "admin.catelog.table.total": "Total {total} items",
  "admin.catelog.btn.add": "Add",
  "admin.catelog.btn.refresh": "Refresh",
  "admin.catelog.btn.edit": "Edit",
  "admin.catelog.btn.delete": "Delete",
  "admin.catelog.bulk.delete": "Delete ({count})",
  "admin.catelog.bulk.confirmDelete": "Are you sure you want to delete the selected categories?",
  "admin.catelog.modal.add": "Add Category",
  "admin.catelog.modal.edit": "Edit Category",
  "admin.catelog.form.id": "No.",
  "admin.catelog.form.name": "Name",
  "admin.catelog.form.namePlaceholder": "Enter category name",
  "admin.catelog.form.sort": "Sort",
  "admin.catelog.form.sortPlaceholder": "Enter sort order",
  "admin.catelog.form.sortTooltip": "Ascending order, sorted by number from low to high",
  "admin.catelog.form.hidden": "Hidden",
  "admin.catelog.form.hiddenTooltip": "When enabled, tools under this category are only visible after login",
  "admin.catelog.confirm.delete": "Are you sure you want to delete category {name}?",
  "admin.catelog.msg.addSuccess": "Added successfully!",
  "admin.catelog.msg.addFailed": "Failed to add!",
  "admin.catelog.msg.updateSuccess": "Updated successfully!",
  "admin.catelog.msg.updateFailed": "Update failed!",
  "admin.catelog.msg.deleteSuccess": "Deleted successfully!",
  "admin.catelog.msg.deleteFailed": "Delete failed!",
  "admin.catelog.msg.toggleSuccess": "Updated successfully",
  "admin.catelog.msg.toggleFailed": "Update failed",
  "admin.catelog.msg.sortSuccess": "Sort order updated",
  "admin.catelog.msg.sortFailed": "Failed to update sort order",
  "admin.search.title": "Search Engine Management",
  "admin.search.total": "Total {count} items",
  "admin.search.table.sort": "Sort",
  "admin.search.table.logo": "Logo",
  "admin.search.table.name": "Name",
  "admin.search.table.urlTemplate": "URL Template",
  "admin.search.table.description": "Description",
  "admin.search.table.enabled": "Enabled",
  "admin.search.table.action": "Actions",
  "admin.search.table.total": "Total {total} items",
  "admin.search.btn.add": "Add Search Engine",
  "admin.search.btn.edit": "Edit",
  "admin.search.btn.delete": "Delete",
  "admin.search.bulk.confirmDelete": "Are you sure you want to delete the selected search engines?",
  "admin.search.bulk.confirmDeleteContent": "About to delete {count} search engines. This action cannot be undone.",
  "admin.search.bulk.confirmDeleteOk": "Confirm Delete",
  "admin.search.bulk.confirmDeleteCancel": "Cancel",
  "admin.search.form.name": "Name",
  "admin.search.form.namePlaceholder": "e.g. Google",
  "admin.search.form.nameRequired": "Please enter the search engine name",
  "admin.search.form.urlTemplate": "Search URL Template",
  "admin.search.form.urlTemplatePlaceholder": "https://www.google.com/search?q={query}",
  "admin.search.form.urlTemplateExtra": "Use {query} or %s as the search keyword placeholder",
  "admin.search.form.urlTemplateRequired": "Please enter the search URL template",
  "admin.search.form.urlTemplateValidator": "Template must contain {query} or %s as the search keyword placeholder",
  "admin.search.form.description": "Description",
  "admin.search.form.descriptionPlaceholder": "Brief description of the search engine (optional)",
  "admin.search.form.logo": "Icon",
  "admin.search.form.logoPlaceholder": "e.g. google.ico or https://example.com/logo.png",
  "admin.search.form.logoRequired": "Please enter an icon filename or URL",
  "admin.search.form.logoValidator": "Please enter a valid URL or icon filename",
  "admin.search.form.autoFetch": "Auto-fetch description and icon",
  "admin.search.form.fillUrlTemplateFirst": "Please fill in the search URL template first",
  "admin.search.form.cannotExtractUrl": "Cannot extract URL from the search URL template",
  "admin.search.form.fetchSuccess": "Fetch complete",
  "admin.search.form.fetchFailed": "Fetch failed: ",
  "admin.search.msg.loadFailed": "Failed to load search engines",
  "admin.search.msg.addSuccess": "Added successfully",
  "admin.search.msg.editSuccess": "Updated successfully",
  "admin.search.msg.deleteSuccess": "Deleted successfully",
  "admin.search.msg.deleteFailed": "Delete failed",
  "admin.search.msg.sortFailed": "Failed to update sort order",
  "admin.apiToken.title": "API Token Management",
  "admin.apiToken.total": "Total {count} items",
  "admin.apiToken.table.id": "No.",
  "admin.apiToken.table.name": "Name",
  "admin.apiToken.table.value": "Value",
  "admin.apiToken.table.action": "Actions",
  "admin.apiToken.table.total": "Total {total} items",
  "admin.apiToken.btn.add": "Add",
  "admin.apiToken.btn.refresh": "Refresh",
  "admin.apiToken.modal.add": "Add Token",
  "admin.apiToken.form.name": "Name",
  "admin.apiToken.form.namePlaceholder": "Enter API token name",
  "admin.apiToken.confirm.delete": "Are you sure you want to delete token {name}?",
  "admin.apiToken.msg.addSuccess": "Token added successfully!",
  "admin.apiToken.msg.addFailed": "Failed to add token!",
  "admin.apiToken.msg.deleteSuccess": "Token deleted successfully!",
  "admin.apiToken.msg.deleteFailed": "Failed to delete token!",
  "admin.settings.btn.submit": "Submit",
  "admin.settings.importExport.title": "Configuration Import / Export",
  "admin.settings.importExport.description": "Backup and restore tools, categories, search engines, API tokens, and settings",
  "admin.settings.btn.export": "Export Configuration",
  "admin.settings.btn.import": "Import Configuration",
  "admin.settings.msg.exportSuccess": "Configuration exported to {filename}",
  "admin.settings.msg.exportFailed": "Export failed",
  "admin.settings.msg.exportFailedDetail": "Export failed: ",
  "admin.settings.msg.importFailed": "Import failed",
  "admin.settings.msg.importFailedDetail": "Import failed: ",
  "admin.settings.msg.importFormatInvalid": "Invalid file format: missing required fields (version, tools, categories, search_engines, api_tokens, settings)",
  "admin.settings.msg.importJsonInvalid": "Invalid file format: please upload a valid JSON file",
  "admin.settings.msg.importSuccess": "✅ Import successful",
  "admin.settings.msg.importSuccessWithError": "⚠️ Import complete (with errors)",
  "admin.settings.msg.importTokenWarning": "⚠️ Contains sensitive token information",
  "admin.settings.msg.languageSynced": "Language switched to {lang} based on server settings",
  "admin.settings.msg.importTokenWarningContent": "The exported configuration file contains full API token values. Please keep this file secure and do not share it or store it in an insecure environment.",
  "admin.settings.modal.importTitle": "Confirm Configuration Import",
  "admin.settings.modal.importConfirm": "Confirm Import",
  "admin.settings.modal.importCancel": "Cancel",
  "admin.settings.modal.importDescription": "About to import the following configuration. Current data will be replaced (tokens are deduplicated by name, settings are merged):",
  "admin.settings.modal.importTokenAlert": "Contains sensitive token information",
  "admin.settings.modal.importTokenAlertContent": "Please ensure the export file comes from a trusted source.",
  "admin.settings.importPreview.module": "Module",
  "admin.settings.importPreview.count": "Count",
  "admin.settings.importPreview.tools": "Tools",
  "admin.settings.importPreview.categories": "Categories",
  "admin.settings.importPreview.searchEngines": "Search Engines",
  "admin.settings.importPreview.apiToken": "API Token",
  "admin.settings.importPreview.settings": "Settings",
  "admin.settings.importPreview.toolSample": "Tool Sample (first 5)",
  "admin.settings.user.title": "Edit User Info",
  "admin.settings.user.username": "Username",
  "admin.settings.user.usernamePlaceholder": "Enter new username",
  "admin.settings.user.password": "Password",
  "admin.settings.user.passwordPlaceholder": "Enter new password",
  "admin.settings.site.title": "Edit Site Info",
  "admin.settings.site.favicon": "Site Logo",
  "admin.settings.site.faviconTooltip": "Enter the logo URL. Only PNG or SVG format is supported",
  "admin.settings.site.faviconPlaceholder": "Enter site logo",
  "admin.settings.site.faviconRequired": "Please enter the site logo URL",
  "admin.settings.site.title_label": "Site Title",
  "admin.settings.site.titlePlaceholder": "Enter site title",
  "admin.settings.site.titleRequired": "Please enter site title",
  "admin.settings.site.govRecord": "Gov Record",
  "admin.settings.site.govRecordPlaceholder": "Enter government record info",
  "admin.settings.site.jumpTarget": "Default Link Target",
  "admin.settings.site.jumpTargetTooltip": "Choose the default link target when clicking a tool card",
  "admin.settings.site.jumpTargetRequired": "This field is required",
  "admin.settings.site.jumpTarget.sameWindow": "Open in same tab",
  "admin.settings.site.jumpTarget.newTab": "Open in new tab",
  "admin.settings.site.logo192": "Logo 192x192",
  "admin.settings.site.logo192Placeholder": "192x192 logo URL",
  "admin.settings.site.logo192Tooltip": "192x192 logo for PWA installable web app",
  "admin.settings.site.logo192Required": "Please enter the 192x192 logo URL",
  "admin.settings.site.logo512": "Logo 512x512",
  "admin.settings.site.logo512Placeholder": "512x512 logo URL",
  "admin.settings.site.logo512Tooltip": "512x512 logo for PWA installable web app",
  "admin.settings.site.logo512Required": "Please enter the 512x512 logo URL",
  "admin.settings.site.hideAdmin": "Hide Admin Panel Card",
  "admin.settings.site.hideAdminTooltip": "Shown by default. When enabled, the admin card is hidden on the frontend",
  "admin.settings.site.hideGithub": "Hide GitHub Button",
  "admin.settings.site.hideGithubTooltip": "Shown by default. When enabled, the GitHub button is hidden on the frontend",
  "admin.settings.site.hideJumpTarget": "Hide Link Target Card",
  "admin.settings.site.hideJumpTargetTooltip": "Shown by default. When enabled, the link target card is hidden on the frontend",
  "admin.settings.site.showSearchEngine": "Show Search Engines",
  "admin.settings.site.showSearchEngineTooltip": "When enabled, shows search engine quick-switch buttons in search. When disabled, only the search box is shown",
  "admin.settings.site.pcColumnCount": "PC Column Count",
  "admin.settings.site.pcColumnCountTooltip": "Number of tool card columns on desktop (2-8), default is 3",
  "admin.settings.site.pcColumnCountPlaceholder": "Default: 3",
  "admin.settings.config.title": "Edit Site Config",
  "admin.settings.config.noImageMode": "No-Image Mode",
  "admin.settings.config.noImageModeTooltip": "When enabled, tool logos and other images are hidden on the frontend",
  "admin.settings.config.compactMode": "Compact Mode",
  "admin.settings.config.compactModeTooltip": "When enabled, cards only show title and logo. If No-Image Mode is also on, only the title is shown",
  "admin.settings.config.faviconApiTemplate": "Logo API Template",
  "admin.settings.config.faviconApiTemplatePlaceholder": "https://favicon.im/{domain}",
  "admin.settings.config.faviconApiTemplateTooltip": "Use {domain} as the domain placeholder. Defaults to https://favicon.im/{domain}",
  "admin.settings.config.faviconApiTemplateRequired": "Please enter the API template",
  "admin.settings.config.faviconApiTemplateValidator": "Template must contain the {domain} placeholder",
  "admin.settings.config.sortByClicks": "Smart Sort (by Usage)",
  "admin.settings.config.sortByClicksTooltip": "When enabled, the All Tools tab will reorder based on click frequency. New tools get a 14-day visibility boost.",
  "admin.settings.config.sortByClicksNote": "Note: When enabled, tools will be reordered based on click frequency in the current browser. Since click data is stored locally (localStorage), the sorting profile will vary per user.",
  "admin.settings.backup.title": "Data Backup",
  "admin.settings.backup.description": "Configure WebDAV cloud storage for automatic database backups",
  "admin.settings.backup.statusLabel": "Last backup status:",
  "admin.settings.backup.statusTime": "Time: {time}",
  "admin.settings.backup.statusValue": "Status: {status}",
  "admin.settings.backup.statusNone": "No backups yet",
  "admin.settings.backup.statusSuccess": "Success",
  "admin.settings.backup.statusUnknown": "Unknown",
  "admin.settings.backup.btnRefresh": "Refresh",
  "admin.settings.backup.webdavUrl": "WebDAV Server URL",
  "admin.settings.backup.webdavUrlPlaceholder": "https://dav.jianguoyun.com/dav/",
  "admin.settings.backup.webdavUrlTooltip": "e.g. https://dav.jianguoyun.com/dav/",
  "admin.settings.backup.webdavUrlRequired": "Please enter the WebDAV server URL",
  "admin.settings.backup.username": "Username",
  "admin.settings.backup.usernamePlaceholder": "Enter WebDAV username",
  "admin.settings.backup.usernameRequired": "Please enter a username",
  "admin.settings.backup.password": "Password",
  "admin.settings.backup.passwordPlaceholder": "Enter WebDAV password",
  "admin.settings.backup.passwordRequired": "Please enter a password",
  "admin.settings.backup.passwordTooltip": "Password is stored encrypted and will not be displayed in plain text",
  "admin.settings.backup.backupDir": "Backup Directory",
  "admin.settings.backup.backupDirPlaceholder": "/",
  "admin.settings.backup.backupDirTooltip": "Backup directory path on WebDAV, defaults to root directory /",
  "admin.settings.backup.enabled": "Enable Backup",
  "admin.settings.backup.scheduleType": "Schedule",
  "admin.settings.backup.scheduleType.daily": "Daily",
  "admin.settings.backup.scheduleType.weekly": "Weekly",
  "admin.settings.backup.scheduleType.monthly": "Monthly",
  "admin.settings.backup.scheduleType.cron": "Custom (Cron)",
  "admin.settings.backup.scheduleTime": "Backup Time",
  "admin.settings.backup.cronExpr": "Cron Expression",
  "admin.settings.backup.cronExprPlaceholder": "0 2 * * *",
  "admin.settings.backup.cronExprTooltip": "Standard cron expression, e.g. 0 2 * * * for daily at 2 AM",
  "admin.settings.backup.cronExprRequired": "Please enter a cron expression",
  "admin.settings.backup.retentionType": "Retention Policy",
  "admin.settings.backup.retentionType.unlimited": "Unlimited",
  "admin.settings.backup.retentionType.days": "Keep last N days",
  "admin.settings.backup.retentionType.weeks": "Keep last N weeks",
  "admin.settings.backup.retentionType.months": "Keep last N months",
  "admin.settings.backup.retentionValue": "Retention Duration",
  "admin.settings.backup.retentionValueRequired": "Please enter retention duration",
  "admin.settings.backup.retentionValuePlaceholder": "Enter a number",
  "admin.settings.backup.retentionUnit.days": "Days",
  "admin.settings.backup.retentionUnit.weeks": "Weeks",
  "admin.settings.backup.retentionUnit.months": "Months",
  "admin.settings.backup.btnTestConnection": "Test Connection",
  "admin.settings.backup.btnBackupNow": "Backup Now",
  "admin.settings.backup.btnSave": "Save Configuration",
  "admin.settings.backup.msg.connectionSuccess": "WebDAV connection successful!",
  "admin.settings.backup.msg.connectionFailed": "Connection failed",
  "admin.settings.backup.msg.connectionTestFailed": "Connection test failed: ",
  "admin.settings.backup.msg.fillRequired": "Please fill in all required fields",
  "admin.settings.backup.msg.backupStarted": "Backup task started. Please refresh later to check status",
  "admin.settings.backup.msg.backupFailed": "Backup failed",
  "admin.settings.backup.msg.backupFailedDetail": "Backup failed: ",
  "admin.settings.backup.msg.configSaved": "Backup configuration saved",
  "admin.settings.backup.msg.saveFailed": "Save failed",
  "admin.settings.backup.msg.saveFailedDetail": "Save failed: ",
  "admin.settings.backup.files.title": "Backup File Management",
  "admin.settings.backup.files.btnRefresh": "Refresh List",
  "admin.settings.backup.files.description": "The following backup files were retrieved from WebDAV cloud. Select any file to restore the database. Please refresh the page after restoration.",
  "admin.settings.backup.files.column.name": "Filename",
  "admin.settings.backup.files.column.time": "Backup Time",
  "admin.settings.backup.files.column.size": "Size",
  "admin.settings.backup.files.column.action": "Actions",
  "admin.settings.backup.files.btnRestore": "Restore",
  "admin.settings.backup.files.emptyLoading": "Loading...",
  "admin.settings.backup.files.emptyText": "No backup files found (please configure WebDAV and run a backup first)",
  "admin.settings.backup.files.tableTotal": "Total {total} items",
  "admin.settings.backup.restore.title": "Confirm Database Restore",
  "admin.settings.backup.restore.content": "About to restore database from backup file {filename}. The current database will be overwritten (a .bak backup will be created automatically). Please refresh the page after restoration. Continue?",
  "admin.settings.backup.restore.btnOk": "Confirm Restore",
  "admin.settings.backup.restore.btnCancel": "Cancel",
  "admin.settings.backup.restore.msg.success": "Database restored successfully. Please refresh the page",
  "admin.settings.backup.restore.msg.failed": "Restore failed",
  "admin.settings.backup.restore.msg.failedDetail": "Restore failed: ",
  "admin.settings.version.title": "Deployment Version",
  "admin.settings.version.current": "Current version:",
  "admin.settings.version.format": "Version format: vMajor.Minor.Patch.Build",
  "admin.settings.msg.updateSuccess": "Settings updated successfully!",
  "admin.settings.msg.updateFailed": "Failed to update settings!",

  "admin.settings.msg.unknownError": "Unknown error",
  "admin.settings.msg.importDetailCategory": "Categories: {count} imported",
  "admin.settings.msg.importDetailTool": "Tools: {count} imported",
  "admin.settings.msg.importDetailSearchEngine": "Search Engines: {count} imported",
  "admin.settings.msg.importDetailToken": "Tokens: {count} imported, {skipped} skipped",
  "admin.settings.msg.importDetailSetting": "Settings: {count} updated",
  "admin.settings.msg.importPartialError": "Some operations had errors:",
  "admin.settings.importPreview.value": "Value",
  "admin.tools.form.hideHint": "Only visible to logged-in users when enabled",
  "admin.tools.form.hide": "Hidden",
  "admin.tools.form.autoFavicon": "Auto-fetch favicon from URL",
  "admin.tools.form.autoDesc": "Auto-fetch description from URL",
  "admin.tools.form.sortHint": "Ascending, sort by number from small to large",
  "admin.tools.form.logoApiHint": "Auto-fetch logo URL using Logo API template for selected tools",
  "admin.tools.form.logoUrlLabel": "Logo URL",
  "admin.tools.form.descLabel": "Description",
  "admin.tools.confirm.deleteSingle": "Are you sure you want to delete {name}?",
  "admin.tools.msg.fillUrlFirst": "Please enter the tool URL first",
  "admin.tools.msg.faviconSuccess": "Favicon fetched successfully",
  "admin.tools.msg.fetchFailed": "Fetch failed",
  "admin.tools.msg.faviconFailed": "Failed to fetch favicon",
  "admin.tools.msg.descSuccess": "Description fetched successfully",
  "admin.tools.msg.descNotFound": "Description not found, please enter manually",
  "admin.tools.msg.descFailed": "Fetch failed, please enter description manually",
  "admin.tools.msg.refreshingIcon": ", refreshing icon cache...",
  "admin.tools.msg.updatingLogo": "Updating logo URLs...",
  "admin.tools.msg.updateLogoComplete": "Update complete: {success} succeeded, {fail} failed",
  "admin.tools.msg.fetchingDesc": "Fetching description...",
  "admin.tools.msg.sortUpdated": "Sort order updated",
  "admin.catelog.form.sortHint": "Ascending, sort by number from small to large",
  "admin.catelog.msg.sortUpdated": "Sort order updated",
  "admin.search.msg.enterLogo": "Please enter icon filename or URL",
  "admin.search.msg.invalidLogo": "Please enter a valid URL or icon filename",
  "admin.search.batch.fetchInfo": "Auto-fetch description and icon",
  "admin.catelog.confirm.bulkDelete": "Delete selected categories?",
  "admin.search.confirm.bulkDelete": "Delete selected search engines?",
  "admin.search.confirm.bulkDeleteContent": "Delete {count} selected search engines?",
  "admin.search.confirm.cancel": "Cancel",
  "admin.search.confirm.deleteContent": "Delete search engine {name}?",
  "admin.search.confirm.deleteSingle": "Confirm Delete",
  "admin.search.confirm.ok": "OK",
  "admin.search.form.descHint": "Search engine description",
  "admin.search.msg.cannotExtractUrl": "Cannot extract domain from URL template",
  "admin.search.msg.enterUrlTemplate": "Please enter URL template",
  "admin.search.msg.fetchComplete": "Fetch description and icon complete",
  "admin.search.msg.fetchFailed": "Fetch failed: ",
  "admin.search.msg.fillUrlFirst": "Please fill in URL template first",
  "admin.search.msg.updateFailed": "Update failed",
  "admin.search.msg.updateSuccess": "Update successful",
  "admin.search.msg.urlTemplateRequired": "URL template must contain {query} or %s",
  "admin.settings.title": "Settings",
  "admin.token.title": "API Tokens",
  "admin.tools.batch.resetCachedIcon": "Reset Cached Icons",
  "admin.tools.batch.resetDefaultIcon": "Reset Default Icons",
  "admin.tools.batch.updateDesc": "Batch Fetch Descriptions",
  "admin.tools.batch.updateLogo": "Batch Fetch Icons",
  "admin.tools.confirm.recacheIcon": "Re-cache selected tools\' icons?",
  "admin.tools.confirm.resetIcon": "Reset selected tools\' icons to default?",
  "admin.tools.form.urlFormat": "URL must start with http:// or https://",
  "admin.tools.health.complete": "Check complete: {alive} alive, {dead} dead",
  "admin.tools.health.organized": "Organized {count} dead links",
  "admin.tools.msg.addSuccessLogo": "Added! Logo will refresh in 3 seconds",
  "admin.tools.msg.checkFailed": "Check failed",
  "admin.tools.msg.errorInfo": "Error Info",
  "admin.tools.msg.networkError": "Network error",
  "admin.tools.msg.organizeFailed": "Organize failed",
  "admin.tools.msg.updateSuccessLogo": "Updated! Logo will refresh in 3 seconds",
  "admin.tools.total.label": "Total",
  "common.delete": "Delete",
  "home.cache.failed": "Cache restore failed",
  "home.cache.networkError": "Network error, trying cache restore",
  "home.searchEngine.category": "Search",
  "home.searchEngine.desc": "Search 「{query}」 in {name}",
  "home.searchEngine.name": "Search with {name}",
  "home.admin.button": "Admin Panel",
};

export default enUS;
